import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";
import ScrollToTop from "./components/ScrollToTop";
import BackToTopButton from "./components/BackToTopButton";
import LandingPage from "./pages/LandingPage";

// Alles außer der Startseite wird erst bei Bedarf geladen, damit das
// initiale Bundle für den wichtigsten Einstiegspunkt klein bleibt.
const Impressum = lazy(() => import("./pages/Impressum"));
const Datenschutz = lazy(() => import("./pages/Datenschutz"));
const AGB = lazy(() => import("./pages/AGB"));
const NotFound = lazy(() => import("./pages/NotFound"));
const DigitaleAbbuchung = lazy(() => import("./pages/features/DigitaleAbbuchung"));
const Guertelpruefungen = lazy(() => import("./pages/features/Guertelpruefungen"));
const Mitgliederverwaltung = lazy(() => import("./pages/features/Mitgliederverwaltung"));

export default function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/digitale-beitragsabbuchung" element={<DigitaleAbbuchung />} />
              <Route path="/guertelpruefungen" element={<Guertelpruefungen />} />
              <Route path="/mitgliederverwaltung" element={<Mitgliederverwaltung />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/agb" element={<AGB />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <BackToTopButton />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}
